export { ThemeProvider, useTheme, withTheme } from '@emotion/react';
export const defaultTheme = {
    colors: {
        primary: '#3A23AD',
        secondary: '#00cee1',
        hover: '#f8f6fd',
        text: {
            secondary: '#ffffff',
        },
        message: {
            error: '#cc1212',
            warning: '#ecaa15',
            info: '#4c3ce2',
        },
    },
    components: {},
};
